import { render, staticRenderFns } from "./bindProduct.vue?vue&type=template&id=d6b6580a&scoped=true&"
import script from "./bindProduct.vue?vue&type=script&lang=js&"
export * from "./bindProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b6580a",
  null
  
)

export default component.exports